import { ajax } from "@/plugins/ajax";

export default {
  namespaced: true,

  actions: {
    assignPlan({ commit, dispatch }, model) {
      return ajax
        .put("Promotion/api/Promoters/assign-plan", model)
        .then(() => {});
    },
    unAssignPlan({ commit, dispatch }, model) {
      return ajax
        .put("Promotion/api/Promoters/unAssign-plan", model)
        .then(() => {});
    },
    remove({ commit, dispatch }, id) {
      return ajax.delete("Promotion/api/PromoterPlan/" + id).then(() => {});
    },
    editNamePromoterPlanApi({ commit, dispatch }, model) {
      return ajax.patch("Promotion/api/PromoterPlan", model).then(() => {});
    },
    PartiesQueryDetails({ commit, dispatch }, model) {
      return new Promise((resolve, reject) => {
        ajax
          .get("/BusinessParties/api/PartiesQuery/account-info/" + model)
          .then(r => {
            resolve(r.data);
          })
          .catch(e => {
            reject(e.response.data);
          });
      });
    },
    DatapartywithId({ commit, dispatch }, model) {
      return new Promise((resolve, reject) => {
        ajax
          .get("BusinessParties/api/CustomersQuery/" + model + "/aaaa")
          .then(r => {
            resolve(r.data);
          })
          .catch(e => {
            reject(e.response.data);
          });
      });
    },
    PartiesQueryDetailswithid({ commit, dispatch }, model) {
      return new Promise((resolve, reject) => {
        ajax
          .get("Credits/api/PartiesQuery/ownerId/" + model)
          .then(r => {
            resolve(r.data);
          })
          .catch(e => {
            reject(e.response.data);
          });
      });
    },
    PartiesQueryName({ commit, dispatch }, model) {
      return new Promise((resolve, reject) => {
        ajax
          .get("Credits/api/PartiesQuery/partyid/" + model)
          .then(r => {
            resolve(r.data);
          })
          .catch(e => {
            reject(e.response.data);
          });
      });
    },
    listProductsSold({ commit, dispatch }) {
      return new Promise((resolve, reject) => {
        ajax
          .get("Credits/api/CommissionQuery/items")
          .then(r => {
            resolve(r.data);
          })
          .catch(e => {
            reject(e.response.data);
          });
      });
    },
    ConvertNameToIdForParty({ commit, dispatch }, model) {
      return new Promise((resolve, reject) => {
        ajax
          .get("Credits/api/PartiesQuery/" + model)
          .then(r => {
            commit("setList", r.data);
            resolve(r.data);
          })
          .catch(e => reject(e));
      });
    },
    ConfirmAnswer({ commit, dispatch }, model) {
      return ajax.post("CMS/api/Forums", model);
    },
    createPlan({ commit, dispatch }, model) {
      return ajax.post("Promotion/api/PromoterPlan", model);
    },
    createProductsPlan({ commit }, input) {
      return ajax.post("Promotion/api/PromoterPlan/BeneficiaryRule", input);
    },
    unassignProduct({ commit, dispatch }, { promoterPlanId, saleProductId }) {
      return new Promise((resolve, reject) => {
        ajax
          .delete(
            "Promotion/api/PromoterPlan/BeneficiaryRule",
            {
              data: {
                promoterPlanId: promoterPlanId,
                saleProductId: saleProductId
              }
            },
            { headers: { "Content-Type": "application/json" } }
          )
          .then(r => {
            resolve(r.data);
          })
          .catch(e => {
            reject(e.response.data);
          });
      });
    },
    updateProductPlan({ commit, dispatch }, model) {
      return ajax.put("Promotion/api/PromoterPlan/BeneficiaryRule", model);
    }
  },
  mutations: {
    setList(state, data) {
      state.list = data;
    },
    setDetails(state, data) {
      state.details = data;
    },
    setLoading(state, value) {
      state.loading = value;
    }
  }
};
